module.exports = __webpack_public_path__ + "assets/img/price.7692e6af.jpg";